import { render, staticRenderFns } from "./PromocionSalud1MesGratis.vue?vue&type=template&id=169d474c&scoped=true&"
import script from "./PromocionSalud1MesGratis.vue?vue&type=script&lang=js&"
export * from "./PromocionSalud1MesGratis.vue?vue&type=script&lang=js&"
import style0 from "./PromocionSalud1MesGratis.vue?vue&type=style&index=0&id=169d474c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "169d474c",
  null
  
)

export default component.exports